<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h5>Select {{campaignDescription.campaign_name}} Columns For Enrich Data List  </h5>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="p-5" />


          <template v-if="account_columns.length != 0">

            <div class="text-center">
              <h5>Account Fields</h5>
              <h6 class="p-5">Select All <input class="ml-5" type="checkbox" v-model="allAccountFieldSelected"></h6>

            </div>


            <vs-row vs-w="12" class="mb-5">
              <vs-col class="p-2" v-for="account_column in account_columns" vs-type="flex" vs-lg="3" vs-sm="3"
                vs-xs="12">


                <input type="checkbox" v-model="selectedAccountFields"
                @change="selectAccountField(account_column)"
                  :value="account_column">
                <h6 class="p-2">{{ account_column.name }}</h6>
              </vs-col>
            </vs-row>

            <!-- <vs-divider class="m-5" />

            <div class="text-center">
              <h5>Contact Fields</h5>
              <h6 class="p-5">Select All <input class="ml-5" type="checkbox" v-model="allContactFieldSelected"></h6>

            </div>


            <vs-row vs-w="12" class="mb-5">
              <vs-col class="p-2" v-for="contact_column in contact_columns" vs-type="flex" vs-lg="3" vs-sm="3"
                vs-xs="12">
                <input type="checkbox" v-model="selectedContactFields" @change="selectContactField(contact_column)"
                  :value="contact_column">
                <h6 class="p-2">{{ contact_column.name }}</h6>
              </vs-col>
            </vs-row> -->


            <div class="text-center mt-10">
              <vs-button class="mr-3 mb-4" @click.prevent="submitForm">Submit</vs-button>
            </div>

          </template>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ChooseCommentsAutocomplete from "@/components/autocomplete/ChooseCommentsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    // this.getDataSource();
  },
  data() {
    return {
      campaignDescription: {},
      selectedCommentField: null,
      please_choose_comment_field: null,
      ChooseCommentsSearchComponentKey: 0,
      companySearchComponentKey: 0,
      account_columns: [],
      contact_columns: [],
      selected_campaign: null,
      selected: [],
      abilities: null,
      allAccountFieldSelected: false,
      allContactFieldSelected: false,
      selectedAccountFields: [],
      selectedContactFields: [],
      selected_campaign_id: null,
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    CampaignAutocomplete,
    moduleCampaignManagement,
    ChooseCommentsAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];




    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {

    this.selected_campaign_id = this.$route.params.campaignId;

    this.getCampaignDescription();
    this.getAllAccountSelectedCampaignColumns();
    // this.getAllContactSelectedCampaignColumns();
    this.getAlreadySelectedAccountCampaignField()

  },
  watch: {
    allAccountFieldSelected: function (val) {
      let self = this;
      self.selectedAccountFields = [];
      if (val) {
        if (self.allAccountFieldSelected) {
          self.account_columns.forEach(function (e) {
            self.selectedAccountFields.push(e);
          })
        }

      }
    },
    // allContactFieldSelected: function (val) {
    //   let self = this;
    //   self.selectedContactFields = [];
    //   if (val) {
    //     if (self.allContactFieldSelected) {
    //       self.contact_columns.forEach(function (e) {
    //         self.selectedContactFields.push(e);
    //       })
    //     }

    //   }
    // }
  },
  methods: {
    getCampaignDescription() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaign",
          self.$route.params.campaignId
        )
        .then(res => {
          self.campaignDescription = res.data;
          console.log(self.campaignDescription);
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectAccountField(item) {

      this.account_columns.filter(function (column) {
        return column.field_id === item.field_id
      })
  
    },
    selectContactField(item) {

      this.contact_columns.filter(function (column) {
        return column === item
      })
    },
    getAlreadySelectedAccountCampaignField() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getAlreadySelectedAccountCampaignField",
          selected_campaign_id
        )
        .then(response => {
          let result = response.data
          self.selectedAccountFields = JSON.parse(result['account_fields']);
          self.selectedContactFields = JSON.parse(result['contact_fields']);
        })
        .catch(err => {
          if (err.response.status === 401) {
            self.$router.replace("/login");
          }
        });
    },
    getAllAccountSelectedCampaignColumns() {


      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumns",
          self.selected_campaign_id
        )
        .then(res => {




              this.account_columns = JSON.parse(res.data);


              console.log("Account Col" , this.account_columns);


              this.account_columns = this.account_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });
       


              
              for (let i = 0; i < this.account_columns.length; i++) {
                this.account_columns[i].field_id = '_' + this.account_columns[i].uuid.replaceAll('-', '_');
              }


           
          

        

        })
        .catch(err => {
          console.log(err);
        });

  
    },
//     getAllContactSelectedCampaignColumns() {


// var self = this;
// self.$store
//   .dispatch(
//     "campaignsManagement/getAllContactSelectedCampaignColumns",
//     self.selected_campaign_id
//   )
//   .then(res => {



//         this.contact_columns = JSON.parse(res.data);

//         this.contact_columns = this.contact_columns.filter(function(ele) {
//               return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' && ele.identifier != 'company_name' 
//             });


//         for (let i = 0; i < this.contact_columns.length; i++) {
//                 this.contact_columns[i].field_id = '_' + this.contact_columns[i].id.replaceAll('-', '_');
//               }

     

  

//   })
//   .catch(err => {
//     console.log(err);
//   });


// },
    goBack: function () {
      this.$router.go(-1);
    },

    submitForm() {



     
 let self = this


      let selectedFilterFields = {}
      selectedFilterFields.selected_account_fields = this.selectedAccountFields
      selectedFilterFields.selected_contact_fields = this.selectedContactFields


  


      selectedFilterFields.campaign_id = this.selected_campaign_id
      selectedFilterFields.user_id = this.user_id;
      selectedFilterFields.type = 'account'
      



      this.$store
        .dispatch("campaignsManagement/addselectedFilterFields", selectedFilterFields)
        .then(res => {

          if (res.data.status = 'success') {

            // this.$vs.notify({
            //   color: "success",
            //   title: "Default Fields Added",
            //   text: "The campaign default fields was added successfully"
            // });

            self.$router.push(
        {
          name: "add-contacts-to-existing-campaign-accounts",
          params: { campaignId: this.selected_campaign_id }
        })
        

            // location.reload();
      }


        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },

  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
